<template>
    <click-to-edit
      v-model="scope.row.scale.criteria"
      placeholder="Внесите критерий"
      :disabled="!isFieldAvailableForEdit(scope.row, 'scale.criteria')"
      style="width: 100%"
      type="textarea"
      @input="saveElementPropChange(scope.row, 'scale', {criteria:$event})"
    ></click-to-edit>
</template>

<script>

import ClickToEdit from "@/components/ClickToEdit";
import {ElementPropTableColumn} from "@/mixins/elementPropTableColumn";
export default {
  name: 'element-desc-table-column',
  components: {ClickToEdit},
  mixins: [ElementPropTableColumn],

  props: {},
  data() {
    return {

    }
  },
  computed: {},
  methods: {

  }
}

</script>

<style scoped lang="scss">
@import "@/assets/css/project-variables";

</style>
